/**
 * The actual text version of each status
 */
const names = {
  "enabled": "Enabled",
  "disabled": "Disabled",
  "expiring": "Expiring",
  "expired": "Expired"
};

export default {
  /**
   * internal mappings for discount statuses
   */
  Enabled: "enabled",
  Disabled: "disabled",
  Expiring: "expiring",
  Expired: "expired",

  /**
   * Accessor for the text version of each status
   */
  getName(value) {
    return names[value] || value;
  }
}
